import { salesPortalApi } from '@/plugins/api-client';

import type { IDocument, ISellingRegion } from '@condo/domain';

export const getSalesPackageTitles = async (params: {
    distributionPartnerId?: number;
    canViewOpenSalesPackageEstates?: boolean;
}): Promise<{ title?: string; salesPackageId?: number }[]> => {
    return salesPortalApi.get('/sales-packages/titles', { params }).then(response => response.data);
};

export const getSalesPackageDocuments = async (
    salesPackageId: number,
    relatedToEstate?: number,
): Promise<{ salesPackageDocuments: IDocument[]; sellingRegions?: ISellingRegion[] }> =>
    salesPortalApi.get(`/sales-packages/${salesPackageId}/documents`, { params: { relatedToEstate } }).then(({ data }) => data);
